<template>
  <full-page-modal
    :title="modalTit"
    :visible="visible"
    :footer="false"
    :confirm-loading="confirmLoading"
  >
    <div slot="content">
      <cube-form
        ref="myForm"
        :model="model"
        @submit.prevent="submitHandler"
        @validate="validateHandler"
      >
        <cube-form-group>
          <cube-form-item :field="fields[0]" />
        </cube-form-group>
        <cube-form-group class="cube-picker-footer footer form-btn-box">
          <cube-button
            type="reset"
            class="cancel-btn cube-btn-light"
            @click="handleCancel"
          >
            {{ $t('message["896"]') }}
          </cube-button>
          <cube-button
            type="submit"
            class="confirm-btn cube-btn-primary"
          >
            {{ $t('message["915"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </full-page-modal>
</template>

<script>
import { mapActions } from 'vuex'
import eventBus from '@/lib/eventBus'
import FullPageModal from '@/components/mobile/FullPageModal'

export default {
  components: {
    FullPageModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      confirmLoading: false,
      model: {
        content: ''
      },
      fields: [
        {
          type: 'textarea',
          modelKey: 'content',
          label: '',
          props: {
            indicator: false,
            maxlength: 200000,
            placeholder: this.$t('message["791"]')
          },
          rules: {
            required: true
          },
          messages: {
            required: this.$t('message["791"]')
          }
        }
      ]
    }
  },
  computed: {
    modalTit () {
      return this.$t('message["716"]')
    }
  },
  created () {
  },
  methods: {
    ...mapActions('inquery/detailData', [
      'inquiryAddComment'
    ]),
    hide () {
      this.$emit('update:visible', false)
    },
    async submitHandler (e) {
      console.log(e)
      if (this.confirmLoading) return

      this.confirmLoading = true
      const chain = await this.inquiryAddComment()
      chain
        .params({
          inquiryid: this.inquiryId,
          content: this.model.content
        })
        .onNetSuccess((res) => {
          this.confirmLoading = false
          this.handleCancel()
        })
        .onSuccess(res => {
          eventBus.$emit('getCommentList')
        })
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
      // console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    },
    handleCancel () {
      this.hide()
      this.$refs.myForm && this.$refs.myForm.reset()
      this.model.content = ''
      this.confirmLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cube-form_standard .cube-validator_invalid {
  display: block;
  .cube-validator-msg {
    align-items: center;
  }
}
.cube-btn {
  width: 48%;
}
</style>
